<template>
    <span
      class="async-tap"
      :class="{
        'is-loading': loading,
        'is-disabled': loading || disabled
      }"
      :title="loading ? loadingTitle : title"
      tabindex="0"
      role="button"
    
      @click.capture.stop.prevent="onClick"

      @keydown.enter.stop.prevent="onClick"
      @keydown.space.stop.prevent="onClick"
    >
      <slot />
      <!-- 叠加 spinner：不依赖 slot 内部是否能转 -->
      <i v-if="loading" class="async-tap__spinner"></i>
      <!-- 可选遮罩（更明确） -->
      <i v-if="loading" class="async-tap__mask"></i>
    </span>
  </template>
  
  <script>
  export default {
    name: "AsyncTap",
    props: {
      action: { type: Function, required: true }, // 必须返回 Promise 或普通值
      disabled: { type: Boolean, default: false },
      title: { type: String, default: "" },
      loadingTitle: { type: String, default: "处理中…" },
    },
    data() {
      return { loading: false }
    },
    methods: {
      async onClick() {
        if (this.disabled || this.loading) return
        this.loading = true
        try {
          await Promise.resolve(this.action())
          this.$emit("success")
        } catch (e) {
          this.$emit("error", e)
          // 你也可以在这里统一 toast
          console.error(e)
        } finally {
          this.loading = false
        }
      }
    }
  }
  </script>
  
  <style scoped>
  .async-tap{
    display: inline-flex;
    align-items: center;
    justify-content: center;
    position: relative;
  
    border-radius: 10px;
    padding: 4px;
  
    cursor: pointer;
    user-select: none;
    -webkit-tap-highlight-color: transparent;
  
    transition: transform .08s ease, background .16s ease, box-shadow .16s ease, opacity .16s ease;
  }
  .async-tap:hover{
    background: rgba(0,0,0,0.06);
    box-shadow: 0 3px 10px rgba(0,0,0,0.12);
    transform: translateY(-1px);
  }
  .async-tap:active{
    transform: scale(0.92);
  }
  .async-tap.is-disabled{
    pointer-events: none;
    opacity: 0.55;
    cursor: default;
  }
  
  /* spinner（右上角小圈） */
  .async-tap__spinner{
    position: absolute;
    top: 3px;
    right: 3px;
    width: 12px;
    height: 12px;
    border-radius: 50%;
    border: 2px solid currentColor;
    border-top-color: transparent;
    opacity: .85;
    animation: asyncTapSpin .75s linear infinite;
    pointer-events: none;
  }
  @keyframes asyncTapSpin{
    from { transform: rotate(0deg); }
    to   { transform: rotate(360deg); }
  }
  
  /* 遮罩（可选，让“正在执行”更明显） */
  .async-tap__mask{
    position: absolute;
    inset: 0;
    border-radius: inherit;
    background: rgba(255,255,255,0.25);
    backdrop-filter: blur(2px);
    pointer-events: none;
  }
  </style>
  